import { ISharedEnvironment } from '@mojang/environment';

const element = document.getElementById('profileAppEnv');
export const envList = {
  dev: 'dev',
  stage: 'stage',
  prod: 'prod'
};
export const envs: string = (element && element.getAttribute('env-val')) || envList.dev;
const env_var = require('../src/environments/' + envs);
const bundleConfig = env_var.bundleConfig;
const { NOT_SET, validate, sharedDefaultEnvironment, sharedEnvironment } = require('@mojang/environment');
export interface IBundleEnvironment extends ISharedEnvironment {
  whitelistedRedirectHosts: string[];
  'url.redeem': string;
  'enable.maintenanceView': boolean;
  'enable.linkAccountRoute': boolean;
  'enable.manageRealms': boolean;
}

const defaultBundleEnvironment = {
  whitelistedRedirectHosts: [NOT_SET],
  'url.redeem': NOT_SET,
  'enable.maintenanceView': false,
  'enable.linkAccountRoute': false,
  'enable.manageRealms': false,
  ...sharedDefaultEnvironment
};

const env: IBundleEnvironment = {
  ...defaultBundleEnvironment,
  ...sharedEnvironment,
  ...bundleConfig
};

export const environment = validate(env, 'bundleConfig');
